import { staticListProductListLineStyles as styles } from "@dillon/Overrides/Widgets/StaticList/StaticListProductListLine";
import { css } from "styled-components";

styles.uomGridItem = {
    ...styles.uomGridItem,
    css: css `
        &:empty{
            display: none!important;
        }
    `
}
